import { forwardRef } from "react";

import Box from "@mui/material/Box";

// === ModalBox used as the first child to the MuiModal component
const modalBoxStyles = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	bgcolor: "background.paper",
	boxShadow: 24,
	p: 4,
	borderRadius: "6px",
};

export const ModalBox = forwardRef((props, ref) => {
	return (
		<Box sx={modalBoxStyles} ref={ref} {...props}>
			{props.children}
		</Box>
	);
});
ModalBox.muiName = Box.muiName;
